import React from 'react';
import PropTypes from 'prop-types';
import SvgImg from '../../components/Svg/SvgImg';

/* eslint-disable indent */
/* eslint-disable max-len */

const WaitingIcon = (
  {
    width,
    height,
    fill,
  },
) => (
  <SvgImg width={width} height={height} viewbox="0 0 300 300" title="waiting">
    <path d="M 150,0 a 150,150 0 0,1 106.066,256.066 l -35.355,-35.355 a -100,-100 0 0,0 -70.711,-170.711 z" fill={fill} />
  </SvgImg>
  );

  WaitingIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
};
WaitingIcon.defaultProps = {
  fill: '#0099ff',
  width: undefined,
  height: undefined,
};
export default WaitingIcon;
